import { createI18n } from 'vue-i18n';
import { getTenantId } from '@/mixins/Helpers';
import merge from 'lodash.merge'

const modules = ['Shop'];

const formatTenantId = () => {
  const tenant = getTenantId();
  if (!tenant) return '';
  return tenant.trim().replaceAll('.', '') + '_';
};

const getModuleLangFile = async (tenantId, module, lang, isModule = true) => {
  if (isModule) {
    const files = import.meta.glob('@/Modules/**/lang/*.json');
    const tenantPath = `/src/Modules/${module}/lang/${tenantId}${lang}.json`;
    const defaultPath = `/src/Modules/${module}/lang/${lang}.json`;

    if (files[tenantPath]) {
      return (await files[tenantPath]()).default;
    } else if (files[defaultPath]) {
      return (await files[defaultPath]()).default;
    } else {
      throw new Error('Lang file not found');
    }
  } else {
    const files = import.meta.glob('./*.json');
    const tenantPath = `./${tenantId}${lang}.json`;
    const defaultPath = `./${lang}.json`;
    
    if (files[tenantPath]) {
      return (await files[tenantPath]()).default;
    } else if (files[defaultPath]) {
      return (await files[defaultPath]()).default;
    } else {
      throw new Error('Lang file not found');
    }
  }
};



const tenantId = formatTenantId();
const loadLangModules = async (lang) => {
  const results = await Promise.all(
    modules.map((module) => getModuleLangFile(tenantId, module, lang))
  );
  return results;
};


const frModules = await loadLangModules('fr');
const enModules = await loadLangModules('en');

let fr = await getModuleLangFile(tenantId, '', 'fr', false);
let en = await getModuleLangFile(tenantId, '', 'en', false);

const french = merge({}, fr, ...frModules);
const english = merge({}, en, ...enModules);


const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'fr',
  messages: {
    en: english,
    fr: french,
  },
});

export default i18n;

